import { ProductOperationProps } from '@components/std-components/ProductOperation'
import '@styles/LandscapeProductCard/style.css'
import classNames from 'classnames'
import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { ProductCardSizes } from '@constants'
import ProductCard from '../../std-components/ProductCard'
import * as css from './style.css'

interface IProductCard extends ProductOperationProps {
  size?: ProductCardSizes
  direction?: ProductCardDirection
}

export enum ProductCardDirection {
  Horizontal,
  Vertical
}

const SkeletonWrapper = ({ children }) => <div style={{ margin: 5 }}>{children}</div>

const sizes = {
  [ProductCardDirection.Vertical]: {
    [ProductCardSizes.Large]: {
      width1: 220,
      width2: 100,
      height1: 234
    },
    [ProductCardSizes.Medium]: {
      width1: 160,
      width2: 100,
      height1: 234
    },
    [ProductCardSizes.Small]: {
      width1: 100,
      width2: 60,
      height1: 234
    },
    [ProductCardSizes.ExtraSmall]: {
      width1: 108,
      width2: 80,
      height1: 122
    }
  },
  [ProductCardDirection.Horizontal]: {
    [ProductCardSizes.Small]: {
      width1: 100,
      width2: 60,
      height1: 234
    }
  }
}

const ProductCardSkeleton: React.FC<IProductCard> = ({
  size = ProductCardSizes.Medium,
  direction = ProductCardDirection.Vertical
}) => {
  const dimensions = sizes[direction][size]
  return (
    <div className={css.productCard}>
      <ProductCard
        size={size}
        cardCss={classNames({
          'landscape-card': direction === ProductCardDirection.Horizontal
        })}
      >
        <Skeleton height={dimensions.height1} />
        <div className='product-card-info'>
          <SkeletonWrapper>
            <Skeleton width={dimensions.width1} height={25} />
          </SkeletonWrapper>
          <SkeletonWrapper>
            {' '}
            <Skeleton width={dimensions.width1} height={30} />
          </SkeletonWrapper>
          <div className='product-card-info-divider-faded' />
          <SkeletonWrapper>
            <Skeleton width={dimensions.width2} height={33} />
          </SkeletonWrapper>
          <SkeletonWrapper>
            <Skeleton width={dimensions.width2} height={33} />
          </SkeletonWrapper>
          <div className='product-card-info-divider-faded' />
        </div>
      </ProductCard>
    </div>
  )
}

export default ProductCardSkeleton
